import { ActionTypes } from '../constants/ActionTypes';


export function setNotis(notifications) {
    return {
        type: ActionTypes.SET_NOTIS,
        notifications
    };
};

export function setNotiCount(notiCount) {
    return {
        type: ActionTypes.SET_NOTI_COUNT,
        notiCount
    };
};


// WEBPACK FOOTER //
// ./src/actions/notifications.js